module.exports = __webpack_public_path__ + "assets/img/three.c6a9c36e.png";